<template>
  <div>
	<v-dialog :value="value" @input="$emit('input')" >
      <v-card> 
	      <v-toolbar class="lighten-2 noshadow">
	          <v-toolbar-title>  <h5 class="modal-title" id="exampleModalLabel">Confirmation message</h5> </v-toolbar-title>
	          <v-spacer></v-spacer>
	           <v-btn icon @click.native="close">
	            <v-icon>close</v-icon>
	          </v-btn>
	        </v-toolbar>
	        
       			 <v-card-title primary-title>
	                <div class="form-group">
	                   <div class="modal-body-confirm distance cleanbluemessage">
                         <span> {{title}}</span>
                      </div>
	                </div>
       		 	</v-card-title>
		       <v-card-actions class="modal-footer">
	        		<v-spacer></v-spacer>
		            <v-btn  depressed @click="close" class="btn-secondary waves-effect waves-light ">Close</v-btn>
		            <v-btn  color="info"  @click.native="saveAction" class="btn-info waves-effect waves-light ">Confirm</v-btn>
		           
		        </v-card-actions>
       		
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog3"
      max-width="290"
    >
      <v-card>
        <v-toolbar class="lighten-2 noshadow ">
          <v-toolbar-title>  <h5 class="modal-title" >Error message</h5> </v-toolbar-title>
        </v-toolbar>
        <v-card-text  class="distance">
        {{errorReturn}}
        </v-card-text>  
        <v-card-actions class="modal-footer">
              <v-spacer></v-spacer>
              
              <v-btn color="info" class="btn-info waves-effect waves-light" @click.native="closeErr">OK</v-btn>
              
            </v-card-actions>       
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>

</style>
<script>
  import { loginService } from '@/components/_service/Users.js'
  export default {
   props:['value','camId','modalTitle','status'],
    data () {
      	return {
      		approve_remark:"",
      		id:this.camId,

          title:"",
          detail:{},
          isReject:false,
          flat_input_active: false,
          errorReturn :"",
          dialog3:false,

		    }
    },
    methods: {
    
       setFocus() {
        // Note, you need to add a ref="search" attribute to your input.
        //this.$refs.approve_remark.focus();
      },
      onFocus: function(event) {
            event.target.focus()
            this.isReject = false
            this.flat_input_active = true;
      },
       close: function () {
       	//  this.id = ""
     		//  this.approve_remark = ""
         // debugger
          this.detail={}
          this.$emit('input')
        },
        closeErr(){
           this.dialog3 = false;
        },
        saveReload(){
        
          let path = "/detail/"+this.id+"/0"
          window.location.href = path
        },
        saveAction(){
            this.detail.id=this.id
            this.detail.status =this.status
            let path = "/detail/"+this.id+"/0"
            if (this.modalTitle =="approve"){
                this.$store.dispatch('updatestatus', this.detail)
                  .then(() => {
                    this.close()
                    if(this.$store.state.updatestatus.status){
                      this.dialog3 = true;
                      this.errorReturn = this.$store.state.updatestatus.status[0];
                    //  this.$router.replace({ name: 'detail', params: { id:  this.id,flightid:0 }});
                    }else{
                     
                         this.saveReload();
                    }
                     
              }).catch(err => {
                    console.log(err )
                   
                 })
              
            }else if (this.modalTitle =="lost"){
             
                 this.$store.dispatch('updatestatus', this.detail)
                  .then(() => 
                      window.location.href = path    
                    //this.$router.push({ name: 'detail', params: { id:  this.id,flightid:0 }})
                  )
                 .catch(err => {
                    console.log(err )
                   
                 }).finally(() => this.loading = false)
                     
                     
              // this.close();   

            }
          
        }
    },
    beforeMount () {   
      //console.log(this.status)

      if (this.modalTitle =="approve"){
            this.title ="Proceed to approve this campaign?"
        }else 
        if (this.modalTitle =="lost"){
           this.title ="Proceed on campaign lost?"
          
      }
    }
  
  }

</script>